
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program/id/[id]",
      function () {
        return require("private-next-pages/program/id/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program/id/[id]"])
      });
    }
  